import type { FC } from 'react';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

import type { TBoardRailLink } from '@/utils/auctions/auctionBoard';
import { cn } from '@/utils/cn';

/**
 * The rail of popular makes and models (spec 014, research R5) — the
 * homepage's strongest internal link into the indexable model pages. The
 * last link always leads to every auction.
 */

export const AuctionBoardRail: FC<{ links: TBoardRailLink[] }> = ({ links }) => (
  <nav aria-label="Popularne marki i modele" className="mt-8 border-t border-neutral-800 pt-6">
    <p className="mb-3 font-oswald text-xs uppercase tracking-[0.35em] text-neutral-400">Szukasz konkretnego modelu?</p>

    <ul className="flex flex-wrap gap-2">
      {links.map((link, index) => {
        const isLast = index === links.length - 1;

        return (
          <li key={link.href}>
            <Link
              href={link.href}
              data-lane="rail"
              data-id={link.href}
              className={cn(
                'inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 font-oswald text-sm uppercase tracking-wide transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-action/70 focus-visible:ring-offset-2 focus-visible:ring-offset-background',
                isLast
                  ? 'border-action/60 text-action hover:bg-action/10'
                  : 'border-neutral-700 text-neutral-300 hover:border-action hover:text-action'
              )}
            >
              {link.label}
              {isLast && <ArrowRight size={14} aria-hidden />}
            </Link>
          </li>
        );
      })}
    </ul>
  </nav>
);
